module.exports = __webpack_public_path__ + "img/src20.67e154e4.jpg";